import { Typography } from '@mui/material';
import EmptyStateGenerateSuggestionsWithAI from 'assets/images/IllustrationGeneratingAiSuggestions.png';
import { colors } from 'crono-fe-common/theme';

const LoadingAISuggestions = () => {
  return (
    <div
      style={{
        display: 'flex',
        position: 'relative',
        width: '100%',
      }}
    >
      <img src={EmptyStateGenerateSuggestionsWithAI} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 24,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <span
          className="loader"
          style={{
            width: 4,
            height: 4,
            fontSize: 4,
          }}
        />
        <Typography
          fontSize={18}
          lineHeight={'32px'}
          fontWeight={500}
          color={colors.intenseBlue}
        >
          Generating AI suggestions
        </Typography>
      </div>
    </div>
  );
};

export default LoadingAISuggestions;
